import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  ListGroupItem,
  UncontrolledButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import kebabcaseKeys from 'kebabcase-keys';
import { format, parse } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { authorizedPyInstance as axios } from '~/utils';

import ReminderModal from '~/components/Reminder/Modal';

const ListGroupItemReminders = ({ data, setDidSaveReminder }) => {
  const [modalAction, setModalAction] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const popModal = (action) => {
    setModalAction(action);
    setIsModalOpen(true);
  };

  const onReassign = (reassignee) => {
    axios
      .put(
        `/api/data/public/notification/${data.id}`,
        kebabcaseKeys({
          ...data.attributes,
          display_name: reassignee && reassignee.attributes.displayName,
          target_uid: reassignee && reassignee.attributes.providerUid,
        }, { deep: true }),
      )
      .then(() => {
        setIsModalOpen(false);

        setDidSaveReminder(true);
      });
  };

  const onSnooze = (snoozeDate) => {
    axios
      .put(
        `/api/data/public/notification/${data.id}`,
        kebabcaseKeys({
          ...data.attributes,
          reminder_date: snoozeDate,
        }, { deep: true }),
      )
      .then(() => {
        setIsModalOpen(false);

        setDidSaveReminder(true);
      });
  };

  const onComplete = () => {
    axios
      .put(
        `/api/data/public/notification/${data.id}`,
        kebabcaseKeys({
          ...data.attributes,
          is_read: true,
        }, { deep: true }),
      )
      .then(() => {
        setDidSaveReminder(true);
      });
  };

  const onDelete = () => {
    axios
      .delete(`/api/data/public/notification/${data.id}`)
      .then(() => {
        setIsModalOpen(false);

        setDidSaveReminder(true);
      });
  };

  return (<>
    <ListGroupItem className="d-flex justify-content-between align-items-center">
      <span>
        <strong>{format(parse(data.reminderDate || data.attributes.reminderDate), 'MM/DD/YY')}</strong>{' '}
        {data.patientFirstName || data.attributes.patientFirstName}{' '}
        {data.patientLastName || data.attributes.patientLastName}{' - '}
        {data.note || data.attributes.note}
      </span>

      <div>
        <UncontrolledButtonDropdown>
          <Button color="success" outline onClick={onComplete} title="Complete">
            <FontAwesomeIcon icon="check" /> Mark as Done
          </Button>

          <DropdownToggle caret outline color="tertiary" />

          <DropdownMenu right>
            <DropdownItem onClick={() => popModal('reassign')}>
              <FontAwesomeIcon icon="user-edit" /> Reassign
            </DropdownItem>

            <DropdownItem onClick={() => popModal('snooze')}>
              <FontAwesomeIcon icon="clock" /> Snooze
            </DropdownItem>

            <DropdownItem className="text-danger" onClick={() => popModal('delete')}>
              <FontAwesomeIcon icon="trash" /> Delete
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledButtonDropdown>
      </div>
    </ListGroupItem>

    <ReminderModal
      data={data}
      isOpen={isModalOpen}
      toggle={toggleModal}
      action={modalAction}
      onReassign={onReassign}
      onSnooze={onSnooze}
      onDelete={onDelete}
    />
  </>);
};

ListGroupItemReminders.propTypes = {
  data: PropTypes.shape().isRequired,
  setDidSaveReminder: PropTypes.func,
};

ListGroupItemReminders.defaultProps = {
  setDidSaveReminder: () => {},
};

export default ListGroupItemReminders;
